import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Select, Button, Card } from "antd";
import { formatDateTime } from "../Customs/formatDateTime";
import { useLocation } from "react-router-dom";
import { notify } from "../../customs/NotifyProvider";
import { AddonServices } from "../../Services/AddonServices";

const { TextArea } = Input;

const AddSS = ({ editorId, closeDrawer, getAddonServices }) => {
  const [form] = Form.useForm();

  const [id, setId ]=useState(editorId)

  const [addonData, setaddonData] = useState([]);


  console.log('AddSS', id);
  // const isEdit = Boolean(id);
  const isEdit = id !== undefined && id !== null;

  const getEditValues = async () => {
    try {
      const request = await AddonServices.AddonServicesById(id);

      if (request?.status && request?.data) {
        setaddonData(request.data);

        form.setFieldsValue(request.data);

      } else {
        notify.error("Something went wrong", request?.message);
        // navigate('/manage-vehicle')
      }

    } catch (error) {
      console.log(error);

    }
  }

  useEffect(() => {
    if (isEdit) {
      getEditValues();
    }
  }, [id]);

  const handleFinish = async (values) => {
    console.log("Form Values:", values);

    const formData = {
      ...values,
      added_by: null,
      added_on: isEdit ? addonData?.added_on : formatDateTime(),
      updated_on: formatDateTime()
    };
    let response;

    if (isEdit) {
      response = await AddonServices.updateAddonServices(id, formData);
    } else {
      response = await AddonServices.addAddonServices(formData);
    }

    if (response.status) {
      notify.success("success", response.message);
      closeDrawer();
      setId(null)
      getAddonServices();
    } else {
      notify.error("Something went wrong!", response.message);
    }

  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
    >
      {/* Name */}
      <Form.Item
        name="name"
        label="Service Name"
        rules={[{ required: true, message: "Please enter service name" }]}
      >
        <Input placeholder="Enter service name" />
      </Form.Item>

      {/* Description */}
      <Form.Item
        name="description"
        label="Description"
        rules={[{ required: true, message: "Please enter description" }]}
      >
        <TextArea rows={4} placeholder="Enter description" />
      </Form.Item>

      {/* Price */}
      <Form.Item
        name="price"
        label="Price"
        rules={[{ required: true, message: "Please enter price" }]}
      >
        <InputNumber
          style={{ width: "100%" }}
          placeholder="Enter price"
          min={0}
        />
      </Form.Item>

      {/* Price Type */}
      <Form.Item
        name="price_type"
        label="Price Type"
        rules={[{ required: true, message: "Please select price type" }]}
      >
        <Select placeholder="Select price type">
          <Select.Option value="fixed">Fixed</Select.Option>
          <Select.Option value="per_km">Per KM</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save Service
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddSS;
